import {IUserProfile} from "../types/IUserProfile";

export const checkHasVerifiedPhone = (userProfile: IUserProfile | null | undefined): boolean => {
    return Boolean(userProfile && userProfile.phone_verified);
};
